<button
	class="sl-text-button sl-text-button--{{ severity() }}"
	[attr.aria-label]="label() || icon()"
	[tabindex]="tabindex()"
	[ngClass]="styleClass()"
	[type]="type()"
	[disabled]="disabled()"
	[data-testid]="TextButtonTestIds.TextButtonElementTestId"
	(click)="onClick.emit($event)">
	@if (icon()) {
		<mat-icon
			class="sl-button-icon material-symbols-outlined"
			[data-testid]="TextButtonTestIds.TextButtonLabelElementTestId">
			{{ icon() }}
		</mat-icon>
	}
	@if (label()) {
		<span
			class="sl-button-label"
			[data-testid]="TextButtonTestIds.TextButtonIconElementTestId">
			{{ label() }}
		</span>
	}
</button>
